import { css } from "@emotion/react"
import { above } from "@mkt/cp/src/styles/Breakpoints"

export const GlobalErrorContainer = css`
  position: absolute;
  z-index: 999;

  .iq-toast {
    align-items: center;
    border-radius: 16px 16px 0 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    left: 0;
    padding: 16px 20px 16px 25px;
    position: fixed;
    transform: translateY(100%);
    transition: transform 0.3s ease;
    width: 100%;
    will-change: transform;
    z-index: 50;

    ${above["m"]} {
      border-radius: 8px;
      left: 50%;
      transform: translateX(-50%) translateY(100%);
      width: 656px;
    }

    &.iq-toast--visible {
      transform: translateY(0);

      ${above["m"]} {
        transform: translateX(-50%) translateY(-10px);
      }
    }

    &.iq-toast--success {
      background-color: #84f593;

      .iq-toast__content-message {
        color: #00421d;
      }
    }

    &.iq-toast--info {
      background-color: #7ff2f8;

      .iq-toast__content-message {
        color: #023949;
      }
    }

    &.iq-toast--error {
      background-color: #ffb7b7;

      .iq-toast__content-message {
        color: #3e0303;
      }
    }

    &.iq-toast--warning {
      background-color: #ffeea6;

      .iq-toast__content-message {
        color: #6a5603;
      }
    }

    .iq-toast__content {
      display: flex;
      flex: 1;
      justify-content: space-between;
      margin-left: 16px;

      .iq-toast__content-message {
        font-weight: 600;
      }

      .iq-toast__content-button {
        background-color: transparent;
        border: none;

        .iq-icon {
          width: 16px;

          svg {
            color: #666666;
          }
        }
      }
    }
  }
`
